import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { Avatar, Badge, Box, ButtonBase } from '@mui/material'
import { useSelector } from 'react-redux'
import { IconBell } from '@tabler/icons'

const NotificationSection = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const { header_info } = useSelector((state) => state.summaryHeader)

  return (
    <>
      <Box
        sx={{
          ml: 2,
          mr: 3,
          [theme.breakpoints.down('md')]: {
            mr: 2,
          },
        }}
      >
        <Badge badgeContent={header_info.notification_unread} max={99} color="error">
          <ButtonBase sx={{ borderRadius: '12px' }}>
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: 'all .2s ease-in-out',
                background: 'transparent',
                color: theme.palette.grey[700],
                '&[aria-controls="menu-list-grow"],&:hover': {
                  background: 'transparent',
                  color: theme.palette.primary.main,
                },
              }}
              aria-haspopup="true"
              onClick={() => navigate('/notification')}
              color="inherit"
            >
              <IconBell stroke={1.5} size="45px" />
            </Avatar>
          </ButtonBase>
        </Badge>
      </Box>
    </>
  )
}

export default NotificationSection
